<div class="modal info-box fade" id="delete" tabindex="-1" role="dialog" aria-labelledby="deleteLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content p25">
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <p class="pb25">Are you sure you want to delete ?</p>
                    </div>
                </div>

                <div class="">
                    <button type="submit" class="btn pull-right btn-danger" ng-click="delete('delete')">
                        Delete
                    </button>
                    <button type="button" class="btn pull-left btn-default" data-dismiss="modal">Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>